import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function RequireAuth({ children }: PropsWithChildren) {
  const auth = useAuth();
  if (auth.loading) return <div className="muted centered">Loading…</div>;
  if (!auth.user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}
